import React, { useEffect } from "react";
import { Container } from "react-bootstrap";

const TermsAndConditions = () => {

    useEffect(() => {
      window.scrollTo(0, 0); // Scroll to top when component is mounted
    }, []);
  return (
    <Container>
      <div class="privacy_text">
        <h2>FindMe: Terms & Conditions</h2>
        <h4>
          <b>Last Updated :</b> 16 June 2025{" "}
        </h4>
        <p>
        Welcome to <b>FindMe!</b> These Terms & Conditions explain the rules you agree
         to follow when using our mobile application. So, whether you're searching 
         for a job or hiring someone for your business. By signing up or continuing 
         to use the app, you accept all the terms mentioned below.
        </p>

        <h4>1. Who Can Use the App?</h4>
        <p>
        To use FindMe, you must:
        </p>
        <ul>
          <li>Be at least 18 years old.</li>
          <li>Provide accurate and complete details during registration.</li>
          <li>Use the app for legal and honest purposes only.</li>
        </ul>
        
        <h4>2. Account Responsibility</h4>
        <p>You are responsible for: </p>
        <ul>
          <li>Keeping your login information private.</li>
          <li>
          All activities done through your account.
          </li>
          <li>
          Informing us if you notice any suspicious activity or unauthorized access.
          </li>
        </ul>
        <p>
        We have the right to suspend or delete accounts, if found breaking the rules.
        </p>

        <h4>3. Using the App</h4>

        <p>
        By using this application, you agree to:
        </p>
        <ul>
          <li>Post only real and truthful information about jobs or yourself.</li>
          <li>Respect others and avoid abusive, illegal, or misleading content.</li>
          <li>Not use the app to scam, spam, or harm others.</li>
        </ul>
        <p>
        If you break these rules, we may remove your content or account without warning.
        </p>

        <h4>4. Job Applications & Hiring</h4>

        <p>
        FindMe is only a platform to connect people and is not responsible for job results, payments, or contracts between users.
        </p>

        <ul>
          <li>
            {" "}
            <b>Job Seekers:</b> You are responsible for the information you share 
            in applications and for attending interviews or jobs you accept.
          </li>
          <li>
            <b>Businesses:</b> You must treat workers fairly and post real job 
            listings. You are responsible for any agreements made between you and the worker.
          </li>
        </ul>

        <h4>5. Content Ownership</h4>
        <p>
        You own the content (like resumes, photos, etc.) you upload. By sharing it with us, 
        you give the permission to display and use it inside the app. We may remove any 
        content that is inappropriate, offensive, or illegal.

        </p>

        <h4>6. Our Rights</h4>
        <p>
          We can:
        </p>
        <ul>
        <li>Make changes to the app or its features anytime.</li>
        <li>Temporarily or permanently stop offering the app.</li>
        <li>Update these terms when needed. We'll inform users through the app if we do.</li>
        </ul>

        <h4>7. Disclaimer</h4>
        <p>
        We try our best to provide trustworthy services, but:
        </p>
        <ul>
        <li>We do not guarantee that you’ll find a job or hire someone successfully.</li>
        <li>We do not take responsibility for any job disputes, missed payments, or bad behavior by users.</li>
        </ul>
        <p>Use the app at your own risk and with caution.</p>
        <h4>8. Termination</h4>
        <p>
        You can stop using the app anytime. We may also suspend or delete your account if you:
        </p>
        <ul>
          <li>Break these terms.</li>
          <li>Harm the app or other users.</li>
          <li>Violate legal rules.</li>
        </ul>

        <h4>9. Contact Us</h4>
        <p>Have questions, feedback, or need help? Reach out through contact us or email us.</p>
      </div>
    </Container>
  );
};

export default TermsAndConditions;
